import React from 'react'
import { components } from 'react-select'

const DropdownIndicator = (props) => {
    return components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
            <div className='dropdownindicator' />
        </components.DropdownIndicator>
    )
}

const orange = '#FFA81D'
const background = '#383d41'
const SelectStyle = {
    control: (styles, { isDisabled }) => ({
        ...styles,
        backgroundColor: isDisabled ? background : background,
        borderColor: isDisabled ? background : orange,
        boxShadow: 'none',
        '&:hover': {
            borderColor: orange,
            boxShadow: 'none'
        },
        color: orange,
        cursor: 'pointer'
    }),
    clearIndicator: (styles) => ({
        ...styles,
        color: orange,
        '&:hover': {
            color: orange
        }
    }),
    indicatorSeparator: (styles, { isDisabled }) => ({
        ...styles,
        backgroundColor: isDisabled ? background : orange,
    }),
    dropdownIndicator: (styles) => ({
        ...styles,
        color: orange,
        '&:hover': {
            color: orange
        }
    }),
    input: (styles) => ({
        ...styles,
        color: orange
    }),
    singleValue: (styles) => ({
        ...styles,
        color: orange,
        cursor: 'pointer'
    }),
    multiValue: (styles) => ({
        ...styles,
        backgroundColor: null
    }),
    multiValueLabel: (styles) => ({
        ...styles,
        color: orange
    }),
    multiValueRemove: (styles) => ({
        ...styles,
        color: orange,
        backgroundColor: null,
        '&:hover': {
            color: orange,
            backgroundColor: '#0000'
        }
    }),
    placeholder: (styles) => ({
        ...styles,
        color: orange,
    }),
    menu: (styles) => ({
        ...styles,
        backgroundColor: background,
        border: '1px solid ' + orange,
        borderColor: orange
    }),
    group: (styles) => ({
        ...styles,

    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
            ...styles,
            backgroundColor: isDisabled
                ? null
                : isSelected ? orange : isFocused ? '#1c2228' : background,
            color: isDisabled
                ? '#ccc'
                : isSelected ? 'black' : isFocused ? orange : orange,
            cursor: isDisabled ? 'not-allowed' : 'default'
        };
    }
}

export { SelectStyle, DropdownIndicator}